module.exports = __webpack_public_path__ + "img/xj4.7481ad17.png";